<!-- cargador/spinner todo en uno y totalmente personalizable para aplicaciones Angular -->
<ngx-ui-loader></ngx-ui-loader>
<!-- Cabecera de página con barra navegadora -->
<app-navbar *ngIf="showHeaderFooter | async">

</app-navbar>
<simple-navbar *ngIf="
  router.url === '/login'
"></simple-navbar>
<app-loading *ngIf="
router.url === '/dashboard-comercial' ||
  router.url === '/dashboard-operative' ||
  router.url === '/dashboard-environment' ||
  router.url === '/dashboard-asset-map' ||
  router.url === '/dashboard-target-net-zero' ||
  router.url === '/dashboard-download' ||
  router.url === '/dashboard-monitoring'||
  router.url === '/dashboard-project-detail' ||
  router.url === '/dashboard-project-detail-inst'
"></app-loading>

<!-- Se encarga de cargar el router con lso diferentes paths - Imprescindible -->
<router-outlet></router-outlet>
<!-- Pie de página -->
<app-footer *ngIf="showHeaderFooter | async">
</app-footer>

<!-- Botón negro que aparece abajo a la derecha y que sirve para facilitar volver al principio de la página -->
<ngx-scrolltop></ngx-scrolltop>
